import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

export const LetterPreviewDialog = ({ open, onOpenChange, previewContent }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>Letter Preview</DialogTitle>
        <DialogDescription>Preview for {previewContent?.client_name}</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        {previewContent?.subject && (
          <div className="p-3 bg-muted rounded-md">
            <Label className="text-xs text-muted-foreground">Subject</Label>
            <p className="font-medium">{previewContent.subject}</p>
          </div>
        )}
        <div className="p-6 bg-white border rounded-md whitespace-pre-wrap font-serif">
          {previewContent?.content}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export const LetterGenerateDialog = ({
  open, onOpenChange, selectedTemplate, clientName,
  generating, onGenerate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Generate PDF Letter</DialogTitle>
        <DialogDescription>Generate a PDF of "{selectedTemplate?.name}" for the selected client</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="p-4 bg-muted rounded-md">
          <p><strong>Template:</strong> {selectedTemplate?.name}</p>
          <p><strong>Client:</strong> {clientName}</p>
        </div>
        <p className="text-sm text-muted-foreground">The PDF will be generated with all client information filled in automatically.</p>
      </div>
      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onGenerate} disabled={generating} data-testid="confirm-generate-btn">
          {generating ? 'Generating...' : 'Generate & Download PDF'}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
